<template>
    <div class="members-box">
        <div class="members">
            <img class="members-img" src="../assets/member-center.png" alt="">
            <div class="members-nav">
                <img src="../assets/members-become-enjoy.png" alt="">
                <p style="margin-left: 10px;">即享会员专属权益</p>
                <p>· 充值5000元享9.5折 充值10000元享9折优惠</p>
                <p>· 简易修补免费</p>
                <p>· 生日当天不限件数8折优惠</p>
                <p>· 三件或者单笔消费1000元以上收送件免费</p>

                <div class="members-code">
                    <img style="width:10rem;" src="../assets/members-code.png" alt="">
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    data(){
        return{
        }
    },

    methods:{
    },
}
</script>

<style scoped lang="scss">
.members-box{
    
    background: #000F51;
}
.members{
    background: #000F51;
    padding: 5rem 20rem;
    color: #F4DFB4;
    display: flex;
    align-items: center;
    text-align: left;
    position: relative;
    

    .members-img{
        width: 55%;
        height: 38rem;
    }

    .members-nav{
        margin-left: 2rem;

        img{
            width: 25rem;
            margin-bottom: 2rem;
        }

        p{
            line-height: 1.5rem;
        }
    }
}
.members-code{
    position: absolute;
    right: 0;
    bottom: 0;
    overflow: hidden;
}
</style>